import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/web.dom-collections.iterator.js";
export var transformReImages = (imageToTransform, formats) => {
  var res = [];
  imageToTransform.forEach(img => {
    var temp = Object.assign({}, img);
    //@ts-ignore
    temp.images = [...img.images];
    var filteredImages = [];
    formats.forEach(f => {
      if (!temp.images) return;
      var curImage = temp.images.find(i => i.format == f);
      if (curImage) filteredImages.push(curImage);else {
        var length = temp.images.length;
        for (var i = length - 1; i >= 0; i--) {
          var firstHQImage = temp.images[i];
          if (firstHQImage) {
            filteredImages.push(firstHQImage);
            break;
          }
        }
      }
    });
    temp.images = filteredImages;
    res.push(temp);
  });
  return res;
};
export var getImageFormat = (img, format) => {
  if (!img.images) return null;
  for (var i of img.images) {
    if (i.format == format) return i;
  }
  return null;
};